import DataTableCommon from 'app_components/commons/dataTable/containers/dataTableCommon'
import AppContainer from 'app_components/layouts/app'
import { CertificateCriteriaTypeCourse, ICertificateCriteria } from 'app_types/admin/certificateCriteria/certificateCriteriaTypes'
import React, { FC, ReactElement, useCallback, useEffect, useMemo, useState } from 'react'
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { IoIosAddCircleOutline } from 'react-icons/io';
import './CertificateCriteria.scss'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent';
import { MdModeEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import ModalAttached from 'app_components/modules/ModalAttached/ModalAttached';
import CertificateCriteriaService from 'app_services/admin/certificateCriteria/CertificateCriteriaService';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';

const TypeCourseText = {
  [CertificateCriteriaTypeCourse.FREE]: 'Gratuito',
  [CertificateCriteriaTypeCourse.MOOC]: 'Mooc',
}

interface ICertificateCriteriaTableItem extends ICertificateCriteria {
  component_render_attach: ReactElement
}

const CertificateCriteria: FC = () => {
  const [attachToShow, setAttachToShow] = useState<string | null>(null)
  const [certificateCriterias, setCertificateCriterias] = useState<ICertificateCriteria[]>([])

  const certificateCriteriaService = useMemo(() => new CertificateCriteriaService(), [])
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])

  const dataTableData = useMemo((): ICertificateCriteriaTableItem[] => {
    return certificateCriterias.map((criteria) => ({
      ...criteria,
      // @ts-ignore
      modality: criteria?.modality?.name,
      typeCourse: criteria?.typeCourse ? TypeCourseText[criteria?.typeCourse] as CertificateCriteriaTypeCourse : undefined,
      component_render_attach: (
        <div className='certificate-criteria--table-icons-container'>
          <TooltipComponent text='Ver criterios'>
            <MdRemoveRedEye onClick={() => setAttachToShow(criteria.certificateCriteria)} className='certificate-criteria--table-icon' />
          </TooltipComponent>
        </div>
      )
    }))
  }, [certificateCriterias])

  const getCertificateCriterias = useCallback(async () => {
    const response = await certificateCriteriaService.list()
    if (response.code === 200) {
      setCertificateCriterias(response?.registers ? response?.registers : [])
    } else {
      setCertificateCriterias([])
    }
  }, [certificateCriteriaService])

  useEffect(() => {
    getCertificateCriterias()
  }, [getCertificateCriterias])

  const handleClickDelete = useCallback(async (certificateCriteriaId: string) => {
    const confirm = await screenNotification.showAskDelete()
    if (confirm.isConfirmed) {
      const response = await certificateCriteriaService.delete({ id: certificateCriteriaId })
      if (response.message === 'success') {
        screenNotification.showSuccessTimer()
        getCertificateCriterias()

      }
    }
  }, [certificateCriteriaService, screenNotification, getCertificateCriterias])

  return (
    <AppContainer>
      <div className='certificate-criteria--layout'>
        <BreadcrumbComponent
          links={[
            '#',
          ]}
          texts={[
            'Criterios de certificación'
          ]}
        />
        <div>
          <h3>Administración de criterios de certificación</h3>
        </div>
        <div className="certificate-criteria--actions-container">
          <Link to={routingService.getSecurePath('/admin/certificate-criteria/new')}>
            <ButtonComponent variant='primary'>
              <ButtonComponent.Icon>
                <IoIosAddCircleOutline />
              </ButtonComponent.Icon>
              Nuevo criterio
            </ButtonComponent>
          </Link>
        </div>
        <DataTableCommon
          data={dataTableData}
          headerKeys={['Modalidad', 'Tipo de curso', 'Criterio de certificación']}
          keys={['modality', 'typeCourse', 'component_render_attach']}
          hideTooltip
          headerStyles={[{ key: 'actions', style: { width: '120px' } }]}
          actionsColTitle='Acciones'
          rowButtons={(certificateCriteria: ICertificateCriteriaTableItem) => (
            <div className='certificate-criteria--table-icons-container'>
              <TooltipComponent text='Editar'>
                <Link to={routingService.getSecurePath(`/admin/certificate-criteria/${certificateCriteria._id}`)}>
                  <MdModeEdit className='certificate-criteria--table-icon' />
                </Link>
              </TooltipComponent>
              <TooltipComponent text='Eliminar'>
                <MdDelete onClick={() => handleClickDelete(certificateCriteria._id as string)} className='certificate-criteria--table-icon' />
              </TooltipComponent>
            </div>
          )}
        />
        <ModalAttached
          open={attachToShow !== null}
          onClose={() => setAttachToShow(null)}
          defaultValue={attachToShow ?? undefined}
          title="Criterios de certificación"
          category='course_scheduling_certificate_criteria'
          disabled
        />
      </div>
    </AppContainer>
  )
}

export default CertificateCriteria
